import { useCallback } from 'react'
import { useCreatePendingBulkRequest } from './create'
import { PendingBulkRequest } from './schema'
import { useUpdatePendingBulkRequest } from './update'

export * from './create'
export * from './delete'
export * from './query'
export * from './update'

type UpdateOrCreateParams = {
  onSuccess?: () => void
}

type Operation = Partial<PendingBulkRequest>

export const useUpdateOrCreatePendingBulkRequest = (
  params?: UpdateOrCreateParams
) => {
  const createPendingBulkRequest = useCreatePendingBulkRequest({
    onSuccess: params?.onSuccess,
  })
  const updatePendingBulkRequest = useUpdatePendingBulkRequest({
    onSuccess: params?.onSuccess,
  })

  const createOrUpdate = useCallback(
    (operation: Operation) => {
      const { id, operationId, viewContext, ...operationAttribures } = operation
      if (id) {
        return updatePendingBulkRequest.mutate({
          id,
          ...operation,
        })
      }

      if (!operationId || !viewContext) return

      return createPendingBulkRequest.mutate({
        operationId,
        viewContext,
        ...operationAttribures,
      })
    },
    [createPendingBulkRequest, updatePendingBulkRequest]
  )

  return createOrUpdate
}
